import { NgModule } from '@angular/core';
import {
  CommonModule,
  DatePipe,
  registerLocaleData,
  CurrencyPipe,
} from '@angular/common';
import { RouterModule } from '@angular/router';

import { NzTreeViewModule } from 'ng-zorro-antd/tree-view';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzAnchorModule } from 'ng-zorro-antd/anchor';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzBackTopModule } from 'ng-zorro-antd/back-top';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCalendarModule } from 'ng-zorro-antd/calendar';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { NzCascaderModule } from 'ng-zorro-antd/cascader';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzCommentModule } from 'ng-zorro-antd/comment';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzI18nModule } from 'ng-zorro-antd/i18n';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzMentionModule } from 'ng-zorro-antd/mention';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzRateModule } from 'ng-zorro-antd/rate';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTransferModule } from 'ng-zorro-antd/transfer';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzResizableModule } from 'ng-zorro-antd/resizable';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconDefinition } from '@ant-design/icons-angular';
import * as AllIcons from '@ant-design/icons-angular/icons';
import { NzIconModule, NZ_ICONS } from 'ng-zorro-antd/icon';
import en from '@angular/common/locales/en';
import { NzConfig, NZ_CONFIG } from 'ng-zorro-antd/core/config';
import { AddUpdateUserComponent } from './common/add-update-user/add-update-user.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AddUpdatePermissionsComponent } from './common/add-update-permissions/add-update-permissions.component';
import { AddUpdateRoleComponent } from './common/add-update-role/add-update-role.component';
import { ChangepasswordComponent } from './common/changepassword/changepassword.component';
import {
  NgxMaskDirective,
  NgxMaskPipe,
  provideNgxMask,
  IConfig,
  provideEnvironmentNgxMask,
} from 'ngx-mask';
import { SelectModule } from 'select/select.module';
import { AddUpdateEmailsDefaultsComponent } from './common/add-update-emails-defaults/add-update-emails-defaults.component';
import { MyprofileComponent } from './common/myprofile/myprofile.component';
import { PhoneChangeVerifyComponent } from './common/myprofile/phone-change-verify/phone-change-verify.component';
import { AddUpdateAgencyComponent } from './common/add-update-agency/add-update-agency.component';
import { AddUpdateAccountComponent } from './common/add-update-account/add-update-account.component';
import { AddUpdateSitesComponent } from './common/add-update-sites/add-update-sites.component';
import { AddUpdateSiteProgramPeriodComponent } from './common/add-update-sites/add-update-site-program-period/add-update-site-program-period.component';
import { AddUpdateSitePreferredPartnersComponent } from './common/add-update-sites/add-update-site-preferred-partners/add-update-site-preferred-partners.component';
import { AddUpdateSitePreferredVendorsComponent } from './common/add-update-sites/add-update-site-preferred-vendors/add-update-site-preferred-vendors.component';
import { AddUpdateRepsComponent } from './common/add-update-reps/add-update-reps.component';
import { ColorPickerComponent } from './common/color-picker/color-picker.component';
import { AddUpdateInvestmentsComponent } from './common/add-update-investments/add-update-investments.component';
import { AddUpdateBillsComponent } from './common/add-update-bills/add-update-bills.component';
import { AddUpdateExpenseComponent } from './common/add-update-expense/add-update-expense.component';
import { AddUpdateInternalTransferComponent } from './common/add-update-internal-transfer/add-update-internal-transfer.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { AddUpdateAnnouncementComponent } from './common/add-update-announcement/add-update-announcement.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { FileDragNDropDirective } from 'src/app/file-drag-n-drop.directive';
import { AddUpdateBadgeComponent } from './common/add-update-badge/add-update-badge.component';
import { AddUpdateAccountTypeComponent } from './common/add-update-account-type/add-update-account-type.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { TextMaskModule, TextMaskConfig } from '../angular2TextMask';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AddUpdateRefundComponent } from './common/add-update-investments/add-update-refund/add-update-refund.component';
import { AddUpdateCreditComponent } from './common/add-update-credit/add-update-credit.component';
import { AddUpdateDepositComponent } from './common/add-update-deposit/add-update-deposit.component';
import { AddUpdateUnderReviewComponent } from './common/add-update-under-review/add-update-under-review.component';
import { EmailTransactionModalComponent } from './common/email-transaction-modal/email-transaction-modal.component';
import { AddUpdateResourceComponent } from './common/add-update-resource/add-update-resource.component';
import { AddUpdateRetailprogramEmaildefaultsComponent } from './common/add-update-retailprogram-emaildefaults/add-update-retailprogram-emaildefaults.component';
import { AddUpdateRetailprogramsComponent } from './common/add-update-retailprograms/add-update-retailprograms.component';
import { AddUpdateSupplierComponent } from './common/add-update-supplier/add-update-supplier.component';
import { MapUnlinkedSupplierComponent } from './common/map-unlinked-supplier/map-unlinked-supplier.component';
import { ModuleDisplayNamePipe } from './pipes/module-display-name.pipe';
import { SplitCamelCasePipe } from './pipes/split-camel-case.pipe';

const maskConfigFunction: () => Partial<IConfig> = () => {
  return {
    validation: false,
  };
};
const ngZorroConfig: NzConfig = {
  message: { nzMaxStack: 1 },
};
const antDesignIcons = AllIcons as {
  [key: string]: IconDefinition;
};
const icons: IconDefinition[] = Object.keys(antDesignIcons).map((key) => {
  const i = antDesignIcons[key];
  return i;
});
registerLocaleData(en);

@NgModule({
  declarations: [
    AddUpdateUserComponent,
    AddUpdatePermissionsComponent,
    AddUpdateRoleComponent,
    ChangepasswordComponent,
    AddUpdateEmailsDefaultsComponent,
    MyprofileComponent,
    PhoneChangeVerifyComponent,
    AddUpdateAgencyComponent,
    AddUpdateAccountComponent,
    AddUpdateSitesComponent,
    AddUpdateSiteProgramPeriodComponent,
    AddUpdateSitePreferredPartnersComponent,
    AddUpdateSitePreferredVendorsComponent,
    AddUpdateRepsComponent,
    ColorPickerComponent,
    AddUpdateInvestmentsComponent,
    AddUpdateBillsComponent,
    AddUpdateExpenseComponent,
    AddUpdateInternalTransferComponent,
    AddUpdateAnnouncementComponent,
    FileDragNDropDirective,
    AddUpdateBadgeComponent,
    AddUpdateAccountTypeComponent,
    AddUpdateRefundComponent,
    AddUpdateCreditComponent,
    AddUpdateDepositComponent,
    AddUpdateUnderReviewComponent,
    EmailTransactionModalComponent,
    AddUpdateResourceComponent,
    AddUpdateRetailprogramEmaildefaultsComponent,
    AddUpdateRetailprogramsComponent,
    AddUpdateSupplierComponent,
    MapUnlinkedSupplierComponent,
    SplitCamelCasePipe,
    ModuleDisplayNamePipe,
  ],
  imports: [
    NgxMaskDirective,
    NgxMaskPipe,
    NgxDocViewerModule,
    CommonModule,
    RouterModule,
    NzAffixModule,
    NzAlertModule,
    NzAnchorModule,
    NzAutocompleteModule,
    NzAvatarModule,
    NzBackTopModule,
    NzBadgeModule,
    NzButtonModule,
    NzBreadCrumbModule,
    NzCalendarModule,
    NzCardModule,
    NzCarouselModule,
    NzCascaderModule,
    NzCheckboxModule,
    NzCollapseModule,
    NzCommentModule,
    NzDatePickerModule,
    NzDescriptionsModule,
    NzDividerModule,
    NzDrawerModule,
    NzDropDownModule,
    NzEmptyModule,
    NzFormModule,
    NzGridModule,
    NzI18nModule,
    NzIconModule,
    NzInputModule,
    NzInputNumberModule,
    NzLayoutModule,
    NzListModule,
    NzMentionModule,
    NzMenuModule,
    NzModalModule,
    NzPageHeaderModule,
    NzPaginationModule,
    NzPopconfirmModule,
    NzPopoverModule,
    NzProgressModule,
    NzRadioModule,
    NzRateModule,
    NzResultModule,
    NzSelectModule,
    NzSkeletonModule,
    NzSliderModule,
    NzSpinModule,
    NzStatisticModule,
    NzStepsModule,
    NzSwitchModule,
    NzTableModule,
    NzTabsModule,
    NzTagModule,
    NzTimePickerModule,
    NzTimelineModule,
    NzToolTipModule,
    NzTransferModule,
    NzTreeModule,
    NzTreeSelectModule,
    NzTypographyModule,
    NzUploadModule,
    NzResizableModule,
    FormsModule,
    NzTreeViewModule,
    ReactiveFormsModule,
    NgMultiSelectDropDownModule,
    SelectModule,
    ScrollingModule,
    NgIdleKeepaliveModule.forRoot(),
    AngularEditorModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    TextMaskModule,
    DragDropModule,
  ],
  exports: [
    // NgxMaskModule,
    NgxMaskDirective,
    NgxMaskPipe,
    CommonModule,
    NzAffixModule,
    NzAlertModule,
    NzAnchorModule,
    NzAutocompleteModule,
    NzAvatarModule,
    NzBackTopModule,
    NzBadgeModule,
    NzButtonModule,
    NzBreadCrumbModule,
    NzCalendarModule,
    NzCardModule,
    NzCarouselModule,
    NzCascaderModule,
    NzCheckboxModule,
    NzCollapseModule,
    NzCommentModule,
    NzDatePickerModule,
    NzDescriptionsModule,
    NzDividerModule,
    NzDrawerModule,
    NzDropDownModule,
    NzEmptyModule,
    NzFormModule,
    NzGridModule,
    NzI18nModule,
    NzIconModule,
    NzInputModule,
    NzInputNumberModule,
    NzLayoutModule,
    NzListModule,
    NzMentionModule,
    NzMenuModule,
    NzModalModule,
    NzPageHeaderModule,
    NzPaginationModule,
    NzPopconfirmModule,
    NzPopoverModule,
    NzProgressModule,
    NzRadioModule,
    NzRateModule,
    NzResultModule,
    NzSelectModule,
    NzSkeletonModule,
    NzSliderModule,
    NzSpinModule,
    NzStatisticModule,
    NzStepsModule,
    NzSwitchModule,
    NzTableModule,
    NzTabsModule,
    NzTagModule,
    NzTimePickerModule,
    NzTimelineModule,
    NzToolTipModule,
    NzTransferModule,
    NzTreeModule,
    NzTreeSelectModule,
    NzTypographyModule,
    NzUploadModule,
    NzResizableModule,
    FormsModule,
    NzTreeViewModule,
    ReactiveFormsModule,
    AddUpdateUserComponent,
    AddUpdatePermissionsComponent,
    AddUpdateRoleComponent,
    AddUpdateAgencyComponent,
    AddUpdateRepsComponent,
    AddUpdateAccountComponent,
    AddUpdateSitesComponent,
    ChangepasswordComponent,
    SelectModule,
    AddUpdateEmailsDefaultsComponent,
    MyprofileComponent,
    AddUpdateInvestmentsComponent,
    AddUpdateBillsComponent,
    AddUpdateExpenseComponent,
    AddUpdateInternalTransferComponent,
    AddUpdateAnnouncementComponent,
    ScrollingModule,
    AngularEditorModule,
    AddUpdateBadgeComponent,
    AddUpdateAccountTypeComponent,
    DragDropModule,
    MatDatepickerModule,
    AddUpdateRefundComponent,
    AddUpdateCreditComponent,
    AddUpdateDepositComponent,
    MatInputModule,
    MatNativeDateModule,
    TextMaskModule,
    AddUpdateUnderReviewComponent,
    EmailTransactionModalComponent,
    AddUpdateResourceComponent,
    AddUpdateRetailprogramEmaildefaultsComponent,
    AddUpdateRetailprogramsComponent,
    AddUpdateSupplierComponent,
    MapUnlinkedSupplierComponent,
    SplitCamelCasePipe,
    ModuleDisplayNamePipe,
  ],
  providers: [
    {
      provide: NZ_ICONS,
      useValue: icons,
    },
    { provide: NZ_CONFIG, useValue: ngZorroConfig },
    provideEnvironmentNgxMask(maskConfigFunction),
    provideNgxMask(),
    DatePipe,
    CurrencyPipe,
  ],
})
export class SharedModule { }
